<template>
  <input
      v-bind:class="inputClass"
      v-model="modelNumber"
      :type="'text'"

  />
</template>
<script>
export default {
  props:{
    value:Number,
    inputClass: {
      type:String,
      default:'main-filter__input--group'
    }
  },
  data() {
    return {
      realNumber:null,

    }
  },
  watch: {
    value: function (val) {
      this.realNumber = val
    }
  },
  computed: {
    modelNumber: {
      get() {
        return this.realNumber ? this.realNumber.toLocaleString(): ""
      },
      set(value) {
        this.realNumber = +value.replace(/\s/g, "")
        this.$emit('input', this.realNumber)
      },
    },
  },
  created() {
    this.realNumber = this.value
  },
}
</script>